import { APIPaths } from "../api-config";
import BaseApi from "../base-api";

export class StoreBannerApi extends BaseApi {
  async getBannerListAll(): Promise<
    APIPaths["/store-app/banner/list-all"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get("/store-app/banner/list-all")).data;
  }
}
